import { t } from 'i18next';
import { Router } from 'src/core/router/Router';
import { ReactComponent as LogoImage } from 'src/icons/logo.svg';
import styled from 'styled-components';

const StyledWrapper = styled.div`
    color: black;
    display: flex;
    width: 22rem;
    font-size: 1.5rem;
    font-weight: 600;
    align-items: center;

    cursor: pointer;

    svg {
        width: 7rem;
    }
`;

export const MerchantLogo = () => {
    return (
        <StyledWrapper
            data-testid="app-header-logo"
            onClick={() => {
                Router.navigateOrReplace('/');
            }}
        >
            <LogoImage data-testid="app-header-logo-image" />
            <Divider />
            <StyledText data-testid="app-header-logo-text">
                {t('App.Logo.Text', 'Merchant Portal')}
            </StyledText>
        </StyledWrapper>
    );
};

const Divider = styled.div`
    height: 2rem;
    width: 2px;
    background-color: rgb(219, 219, 219);
    margin-left: 1rem;
    margin-right: 1rem;
    display: none;

    @media (min-width: 768px) {
        display: block;
    }
`;

const StyledText = styled.div`
    font-size: 1.25rem;
    font-weight: 600;
    color: #ababab;
    display: none;

    @media (min-width: 768px) {
        display: block;
    }
`;
